import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import MultiPhotoes from "./pages/MultiPhotoes";
import Photoes from "./pages/Photoes";
import SingleCart from "./pages/SingleCart";
import MultiRealTime from "./pages/MultiRealTime";
import UserManagement from "./pages/UserManagement";
import PermissionManagement from "./pages/PermissionManagement";
import SwanSong from "./pages/SwanSong";
import WifiReport from "./pages/WifiReport";
import LoginScreen from "./pages/LoginScreen";
import MissingDevicesReport from "./pages/MissingDevicesReport";
import UserLogIn from "./pages/UserLogIn";
import ModeSelection from "./pages/ModeSelection";
import MdmLanding from "./pages/MdmLanding";
import { getToken } from "./utils/auth";
import { useEffect } from "react";

// Custom higher-order component (HOC) for route authentication
const PrivateRoute = ({ children }) => {
  if (!getToken()) return <Navigate to="/" />;
  return children;
};

function App() {
  useEffect(() => {
    const onStorage = (event) => {
      // Ignore unrelated storage updates to avoid false redirects.
      if (event.storageArea !== window.localStorage) return;
      const authTokenChanged = event.key === "authToken";
      const storageCleared = event.key === null;
      if (!authTokenChanged && !storageCleared) return;
      if (authTokenChanged && event.newValue !== null) return;

      if (!getToken() && window.location.pathname !== "/") {
        window.location.assign("/");
      }
    };
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener("storage", onStorage);
    };
  }, []);
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<UserLogIn />} />
        <Route
          path="/platform-selection"
          element={
            <PrivateRoute>
              <ModeSelection />
            </PrivateRoute>
          }
        />
        <Route
          path="/Branch"
          element={
            <PrivateRoute>
              <LoginScreen />
            </PrivateRoute>
          }
        />
        <Route
          path="/mdm"
          element={
            <PrivateRoute>
              <MdmLanding />
            </PrivateRoute>
          }
        />
        <Route
          path="/Home/:retailer/:store"
          element={
            <PrivateRoute>
              <Home />
            </PrivateRoute>
          }
        />
        <Route
          path="/cart/:device_id/:serial_number/:retailer/:store"
          element={
            <PrivateRoute>
              <SingleCart />
            </PrivateRoute>
          }
        />
        <Route
          path="/multi/photos/:serials/:retailer/:store"
          element={
            <PrivateRoute>
              <MultiPhotoes />
            </PrivateRoute>
          }
        />
        <Route path="/photos/:device_id/:serial_number" element={<Photoes />} />
        <Route
          path="/multi/realtime/:serials/:retailer/:store"
          element={<MultiRealTime />}
        />
        <Route
          path="/multi/wifi-report/:serials/:retailer/:store"
          element={
            <PrivateRoute>
              <WifiReport />
            </PrivateRoute>
          }
        />
        <Route path="/swansong/:device_id" element={<SwanSong />} />
        <Route path="/UserManagement" element={<PrivateRoute><UserManagement /></PrivateRoute>} />
        <Route path="/PermissionManagement" element={<PrivateRoute><PermissionManagement /></PrivateRoute>} />
        <Route
          path="/missing-devices-report/:retailer/:store"
          //element={<ProtectedRoute element={MissingDevicesReport} />}
          element={<MissingDevicesReport />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
